import c from 'classnames';
import { Icon, IconName } from '../Icon';
import styles from './Pill.module.css';

type PillGenericProps = {
  className?: string;
  onClick?: () => Promise<void> | void;
  iconNameLeft?: IconName;
  iconNameRight?: IconName;
  iconClassName?: string;
};

type WithLabel = {
  label: string;
  children?: never;
};

type WithChildren = {
  label?: never;
  children: React.ReactNode;
};

type PillProps = PillGenericProps & (WithLabel | WithChildren);

export function Pill({
  children,
  label,
  className,
  onClick,
  iconNameLeft,
  iconNameRight,
  iconClassName,
}: PillProps) {
  return (
    <div
      role='button'
      className={c(
        styles.pill,
        onClick && styles.clickable,
        iconNameLeft && styles.hasIconLeft,
        iconNameRight && styles.hasIconRight,
        className,
      )}
      onClick={onClick}
    >
      {iconNameLeft && (
        <Icon name={iconNameLeft} className={c(styles.icon, iconClassName)} />
      )}
      {label ?? children}
      {iconNameRight && (
        <Icon name={iconNameRight} className={c(styles.icon, iconClassName)} />
      )}
    </div>
  );
}
